// test1729
(1729 && 0);
